import { getI18nJsonProp } from "@/shared/i18n/locales/getI18nJsonProp";
import base from "./base.json";
import cardsArchive from "./cards-archive.json";
import cardsOverview from "./cards-overview.json";
import orders from "./orders.json";
import shared from "./shared.json";

const wccManagement = {
  ...getI18nJsonProp(base, "wccManagement"),
  ...getI18nJsonProp(cardsArchive, "wccManagement"),
  ...getI18nJsonProp(cardsOverview, "wccManagement"),
  ...getI18nJsonProp(orders, "wccManagement"),
  ...getI18nJsonProp(shared, "wccManagement"),
};

export default wccManagement;
